import { createSlice } from '@reduxjs/toolkit';
import * as accountingService from '../services/accountingService';
import config from '../config';

const initialState = {
    loading : false,
    hasErrors : false,
    jurnals : [],
    jurnal : {},
    list_page : [],
    pesan : ''
}

const jurnalStoreSlice = createSlice({
    name : 'jurnalStore',
    initialState,
    reducers : {
        getData : (state) => { state.loading = true},
        getDataSuccess : (state, action) => {
            state.loading = false;
            state.hasErrors = false;
            state.jurnals = action.payload.data;
            state.list_page = action.payload.list_page;
        },
        getDataFailure : (state) => { state.loading = false; state.hasErrors = true},
        setDetail : (state, action) => {
            state.loading = false;
            state.hasErrros = false;
            state.jurnal = action.payload;
        },
        deleteData : (state, action) => {            
            state.loading = false;
            state.hasErrors = false;
            state.jurnals = state.jurnals.filter(item => item.id !== action.payload);
        },
        setPesan : (state, action) => {
            state.pesan = action.payload;
        }
    }
})

export const { getData, getDataSuccess, getDataFailure, setDetail, deleteData, setPesan } = jurnalStoreSlice.actions;

export const jurnalSelector = (state) => state.jurnals;

export default jurnalStoreSlice.reducer;


export function fetchJurnal(q='', limit=config.itemPerPage, page=1){
    return async(dispatch) => {
        dispatch(getData());
        try{
            const response = await accountingService.getJurnal(q, limit, page);
            const data = await response;            
            if(data.sukses === 'yes'){
                dispatch(getDataSuccess(data))
            }else{
                dispatch(getDataFailure());
            }
        }catch(error){
            dispatch(getDataFailure());
        }
    }
}


export function fetchDetail(id){
    return async(dispatch) => {
        dispatch(getData());
        try{
            const response = await accountingService.getJurnal(`id=${id}`, 1, 1);
            const data = await response;            
            if(data.sukses === 'yes'){
                dispatch(setDetail(data.data))
            }else{
                dispatch(getDataFailure());
            }
        }catch(error){
            dispatch(getDataFailure());
        }
    }
}
